const StoreIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      fill="#212124"
      d="M15 11.5h-.5V3.619l.604-.13a.5.5 0 1 0-.209-.978l-14 3a.5.5 0 0 0 .21.978l.395-.085V11.5H1a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1Zm-3.5 0h-7v-1h7v1Zm0-2h-7v-1h7v1Z"
    />
  </svg>
);
export default StoreIcon;
